import { get } from 'lodash';
import React from 'react';
import formatPrice from 'services/helpers/formatPrice';

const TotalField = (props) => {
  const { record } = props;

  const isCreditCode = record.type.includes('CREDIT_CODE');
  const amounts = get(record, 'amounts');

  if (isCreditCode || !amounts) {
    return <span> - </span>;
  }

  const currency = Object.keys(amounts).find((key) => key !== 'LABEL');

  let value =
    record.details?.totalAmount ??
    (record.details?.baseAmount ?? 0) + (record.details?.stripeFee ?? 0);

  if (!value) {
    if (!currency) {
      return <span>-</span>;
    }
    value = record.amounts?.[currency];
  }

  return <span>{!!value ? formatPrice(value, { currency }) : '-'}</span>;
};

export default TotalField;
